export const environment = {
  production: true,
  APP_ENV: 'prod',
  APP_MAIN_SITE_URL: 'https://topcms.thaioilgroup.com',
  APP_MAIN_API: 'https://topcms.thaioilgroup.com/backend',
  APP_AD_CLIENT_ID: 'e49d79db-e001-41eb-bb28-97e1f653a844',
  APP_AD_TENANT_ID: '894f6e4e-e59c-47ff-be1e-b63a852cfb53',
  APP_B2C_URL: 'https://ThaioilB2C.b2clogin.com',
  APP_B2C_CLIENT_ID: '7e505c9b-30ae-494e-9d53-dd5ffbb6781a',
  APP_B2C_TENANT_ID: 'bbc84d77-54c7-4757-833e-18767c7ee47b',
  APP_B2C_POLICY: 'B2C_1_ThaioilB2C-PRD-SignIn-Reset-Email',
};